import * as React from "react"

function LogoSvg(props) {
  return (
    <svg
      width={90}
      height={100}
      viewBox="0 0 90 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M59.611.17c-2.335.458-3.503 1.129-4.584 2.646-1.558 2.152-15.446 31.89-15.663 33.513-.216 1.658 1.167 4.162 2.94 5.22 3.546 2.115 9.082 1.162 11.028-1.943C54.89 37.172 68.346 7.962 68.52 6.657c.13-.81 0-2.046-.26-2.716C67.613 2.39 64.716.168 63.288.168c-.562 0-1.297-.07-1.643-.14-.303-.07-1.211 0-2.033.141zM4.427 2.016C1.357 3.393-.46 6.144.101 8.508.62 10.765 15.361 41.52 16.312 42.33c3.416 2.962 9.6 2.396 11.98-1.061 1.773-2.576 1.644-3.105-6.57-20.492-4.15-8.818-7.91-16.436-8.343-16.894C11.607 1.909 6.85.922 4.427 2.016zM26.906 47.408c-1.86.953-2.378 1.447-10.424 10.62-3.98 4.55-7.527 8.996-7.873 9.807-.563 1.34-.563 1.764-.044 3.07.346.846 4.496 7.264 9.252 14.318 7.998 11.85 8.776 12.837 10.55 13.789l1.945.988 23.267-.006c25.69-.006 24.997.065 27.463-2.229 3.07-2.822 2.077-7.266-2.031-9.206-1.47-.705-2.335-.74-21.97-.912l-20.455-.171-5.837-8.64c-3.156-4.727-5.793-8.782-5.793-8.994 0-.176 2.12-2.752 4.672-5.645l4.628-5.292 11.893-.179c11.46-.18 11.937-.214 13.277-.99 1.514-.883 3.158-3.352 3.158-4.763 0-1.27-1.08-3.386-2.29-4.41-2.076-1.797-2.293-1.833-17.689-1.83-13.277.004-14.487.075-15.699.675z"
        fill={props.color?props.color:"#7124BD"}
      />
      <path
        d="M65.092 58.122c-.908.423-1.903 1.094-2.25 1.482-.302.388-2.162 3.775-4.11 7.479-3.936 7.655-4.326 9.278-2.51 11.429 1.557 1.904 3.546 2.786 6.227 2.785 4.67-.001 5.752-.989 10.122-9.314 4.11-7.761 4.5-9.384 2.9-11.677-1.513-2.08-3.416-2.997-6.357-2.996-1.73 0-2.854.212-4.022.812zM81.394 66.478c-2.032.494-3.46 1.976-5.363 5.61-2.034 3.845-2.294 5.89-.91 7.725 2.248 2.997 7.654 3.455 10.509.88 1.514-1.412 4.326-7.233 4.37-9.102.044-3.598-4.28-6.172-8.606-5.113z"
        fill={props.color?props.color:"#7124BD"}
      />
    </svg>
  )
}

export default LogoSvg
